import { render, staticRenderFns } from "./MenuBnRetour.vue?vue&type=template&id=77811e61&scoped=true&"
import script from "./MenuBnRetour.vue?vue&type=script&lang=js&"
export * from "./MenuBnRetour.vue?vue&type=script&lang=js&"
import style0 from "./MenuBnRetour.vue?vue&type=style&index=0&id=77811e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77811e61",
  null
  
)

export default component.exports